module.exports = __webpack_public_path__ + "static/PRIME-0698309a716763aa2481b19e4076edd0.svg";